module.exports = __webpack_public_path__ + "img/65.149d61bd.svg";